import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { ServiceItem } from '../../models/service-item.model';
import { LookupService } from '../../services/lookup.service';

@Component({
    selector: 'service-selector',
    templateUrl: 'service-selector.component.html',
    styleUrls: ['service-selector.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ServiceSelectorComponent {
    @Input() parentFormGroup: FormGroup;
    @Input() placeholderText: string;
    @Input() controlName: string;

    readonly services$: Observable<ServiceItem[]>;

    constructor(lookupService: LookupService) {
        this.services$ = lookupService.getServices();
    }
}
